import React from "react";
import PropTypes from "prop-types";
import ProfileMenu from "../ProfileMenu/ProfileMenu";
import "./Header.scss";

function Header({ email, onSignOut }) {
  return (
    <header className="topbar">
      {/* ── Left: Logo only ───────────────────────────────────────────── */}
      <div className="topbar__left">
        <img src="/Topcon_logo.png" alt="Topcon" className="topbar__logo" />
      </div>

      {/* ── Center: App Name + Subtitle ───────────────────────────────── */}
      <div className="topbar__center">
        <span className="topbar__app-name">Video Localization</span>
        <span className="topbar__app-subtitle">
          Video&nbsp;·&nbsp;Subtitle&nbsp;·&nbsp;Synchronisation
        </span>
      </div>

      {/* ── Right: Profile Menu (Logout) ──────────────────────────────── */}
      <div className="topbar__right">
        <div className="topbar__user-info">
          <span className="topbar__user-label">Signed in as</span>
          <span className="topbar__user-email">{email}</span>
        </div>
        <ProfileMenu email={email} onSignOut={onSignOut} />
      </div>
    </header>
  );
}

Header.propTypes = {
  email: PropTypes.string,
  onSignOut: PropTypes.func,
};

export default Header;
